@if (isLoading) {
  <app-chart-loading></app-chart-loading>
} @else {
  <div style="overflow-x: auto"
       [style.maxHeight.px]="config.maxHeight"
       [style.overflowY]="config.maxHeight ? 'auto' : null">
    <div [id]="config.chartId" class="bar-canvas"></div>
  </div>
}
